/* Home page Instagram feed (Instafeed app block in apps_EkQn3q): always full rows, never a hole.
   Keeps the posts that are not hidden (the two old-logo posts, see bh-footer.css) and whose image
   did not fail to load, then shows as many full rows as they fill: 6 x 2 on desktop (5 x 2 or
   4 x 2 when posts are missing, one row as a last resort), 2 x 2 on phones. The app renders the
   feed late and again on resize, so this re-runs on every change inside the section.
   Without JS, bh-home.css section 4c caps the grid at 12 / 4 posts. */
(function () {
  var sec = document.querySelector('.shopify-section[id$="__apps_EkQn3q"]');
  if (!sec) return;
  var OLD_LOGO = /722960386_18595269946009672|657323368_1668661277463074/;
  var phone = window.matchMedia('(max-width: 767.98px)');
  var queued = false;

  function broken(item) {
    var img = item.querySelector('img');
    if (!img) return true;
    var src = img.getAttribute('src') || '';
    return img.complete && /^https?:/.test(src) && img.naturalWidth === 0;
  }

  function fit() {
    queued = false;
    var wrap = sec.querySelector('.instafeed-new-layout-wrapper');
    if (!wrap) return;
    var items = Array.prototype.slice.call(wrap.querySelectorAll('.instafeed-new-layout-item'));
    if (!items.length) return;
    var ok = items.filter(function (item) {
      return !OLD_LOGO.test(item.getAttribute('data-instafeed-thumbnail') || '') && !broken(item);
    });

    var cols, rows;
    if (phone.matches) {
      cols = 2;
      rows = Math.min(2, Math.floor(ok.length / 2)) || 1;
    } else {
      cols = [6, 5, 4].filter(function (c) { return ok.length >= c * 2; })[0];
      rows = 2;
      if (!cols) { cols = Math.min(6, ok.length); rows = 1; }
    }
    var keep = ok.slice(0, cols * rows);

    wrap.classList.add('bh-ig-js');
    wrap.style.setProperty('grid-template-columns', 'repeat(' + cols + ', minmax(0, 1fr))', 'important');
    items.forEach(function (item) {
      item.classList.toggle('bh-ig-off', keep.indexOf(item) === -1);
    });
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(fit);
  }

  new MutationObserver(queue).observe(sec, { childList: true, subtree: true });
  sec.addEventListener('error', queue, true);
  sec.addEventListener('load', queue, true);
  if (phone.addEventListener) phone.addEventListener('change', queue);
  queue();
})();
